import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Inferences as Token',
    paragraph: 'AI training requires massive amounts of data to infer a certain concept. This means that AI fits data into models to help it infer what the correct answer is. For example, if you needed to train the AI what a dog was, it would have to analyze thousands or even millions of pictures of dogs.'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-01.svg')}
                      alt="Features tile icon 01"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    DataSets
                    <h5 className="mt-0 mb-8">
                      storage
                    </h5>
                    </h4>
                  <p className="m-0 text-sm">
                    AI training requires massive category specific DataSets to build models for inferences and are removed from the final inference products.
                    Our goal is to preserve these raw data as public datasets.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-02.svg')}
                      alt="Features tile icon 02"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                   Tokenize
                    <h5 className="mt-0 mb-8">
                    Inferences
                    </h5>
                    </h4>
                  <p className="m-0 text-sm">
                    AI training produces Inferences to help it understand the correct answer when it encounters new data.  These inferences are encoded as tokens and can be stacked to form categories of AI understanding.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-03.svg')}
                      alt="Features tile icon 03"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Stackable
                    <h5 className="mt-0 mb-8">
                    Inferences
                    </h5>
                    </h4>
                  <p className="m-0 text-sm">
                    Multiple tokens stack together to classify AI understanding
                    </p>
                </div>
              </div>
            </div>

            {/* <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-04.svg')}
                      alt="Features tile icon 04"
                      width={64}
                      height={64} />
                  </div>
                </div>
                
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    $450/Month
                    <h5 className="mt-0 mb-8">
                      IT Services
                    </h5>
                    </h4>
                  <p className="m-0 text-sm">
                    Computer and network suport with troubleshooting and installation of trading tools.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-05.svg')}
                      alt="Features tile icon 05"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Professional Services
                    <h5 className="mt-0 mb-8">
                    A la carte
                    </h5>
                  </h4>
                  <p className="m-0 text-sm">
                  One-on-one training and consultation.
                  </p>
                  <p className="m-0 text-sm">
                  Build and modify algorithms.
                  </p>
                </div>
              </div>
            </div> */}
            
          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;